<script setup lang="ts">
import { AppSelectSearchable } from '@shared/ui/selects'

import { useLessonActiveTutorSelect } from '../../model/lessons/lesson-active-tutor-select.hook'

defineOptions({
  name: 'LessonActiveTutorSelect',
})

withDefaults(defineProps<{
  disabled?: boolean
}>(), {
  disabled: false,
})

const model = defineModel<number>({ default: 0 })

const {
  refTutorId,
  refTutorOptions,
  refSelectedOption,
  refHasMore,
  refIsLoading,
  onSearch,
  onLoadMore,
  onOpen,
} = useLessonActiveTutorSelect({ tutorId: model })
</script>

<template>
  <AppSelectSearchable
    v-model="refTutorId"
    :options="refTutorOptions"
    :selected-option="refSelectedOption"
    :has-more="refHasMore"
    :loading="refIsLoading"
    :disabled="disabled"
    label="Tutor"
    placeholder="-- Not selected --"
    infinite
    @search="onSearch"
    @load-more="onLoadMore"
    @open="onOpen"
  />
</template>
